import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List as ImmutableList } from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import PanelLayout from './panel_layout'
import List from '../list'

class GroupAdminPanel extends ImmutablePureComponent {

  render() {
    const { group, noPanel, requestsCount, moderationCount } = this.props

    if (!group) return <div />
    
    const groupId = group.get('id')

    const listItems = [
      {
        title: 'Edit group',
        icon: 'pencil',
        to: `/groups/${groupId}/edit`,
      },
      {
        title: 'Group members',
        icon: 'group',
        to: `/groups/${groupId}/members`,
      },
      {
        title: 'Removed accounts',
        icon: 'block',
        to: `/groups/${groupId}/removed-accounts`,
      },
      {
        title: `Moderation · ${moderationCount}`,
        icon: 'warning',
        to: `/groups/${groupId}/moderation`
      },
      {
        title: `Requests · ${requestsCount}`,
        icon: 'list',
        to: `/groups/${groupId}/requests`
      },
    ]

    return (
      <PanelLayout
        noPanel={noPanel}
        title="Admin options"
        noPadding
      >
        <div className={[_s.d, _s.boxShadowNone, _s.boxShadowNoneBg].join(' ')}>
          <List items={listItems} size='large' />
        </div>
      </PanelLayout>
    )
  }

}

const mapStateToProps = (state, { groupId }) => ({
  group: state.getIn(['groups', groupId]),
  relationships: state.getIn(['group_relationships', groupId]),
  moderationCount: state.getIn(['group_lists', 'group_moderation', groupId, 'count']),
  requestsCount: state.getIn(['user_lists', 'group_join_requests', groupId, 'items'], ImmutableList()).size,
})

GroupAdminPanel.propTypes = {
  groupIds: ImmutablePropTypes.list,
  isLazy: PropTypes.bool, 
  shouldLoad: PropTypes.bool,
  groupType: PropTypes.string,
}

export default connect(mapStateToProps)(GroupAdminPanel)
